import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import SurgicalPendencyService from 'presentation/contexts/services/surgical-pendency-service'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalPendencyRepository } from 'repository/repositories/surgical-pendency/surgical-pendency-repository'
import { RemoteAnswerSurgicalPendency } from 'service/usecases/answer-surgical-pendency/remote-answer-surgical-pendency'
import { RemoteUploadSurgicalPendencyDocument } from 'service/usecases/upload-surgical-pendency-document/remote-upload-surgical-pendency-document'
import { RemoteLoadSurgicalPendencyDocument } from 'service/usecases/load-surgical-pendency-document/remote-load-surgical-pendency-document'
import { RemoteLoadDashboardPendencyCount } from 'service/usecases/load-surgical-order-dashboard-pendency-count/remote-load-surgical-order-dashboard-pendency-count'
import { RemoteLoadSurgicalOrdersByPendencyStatus } from 'service/usecases/load-surgical-orders-by-pendency-status/remote-load-surgical-orders-by-pendency-status'
import { RemoteLoadSurgicalOrderPendencies } from 'service/usecases/load-surgical-order-pendencies/remote-load-surgical-order-pendencies'
import { RemoteLoadSurgicalOrderPendenciesHistory } from 'service/usecases/load-surgical-order-pendencies-history/load-surgical-order-pendencies-history'
import { RemoteRemoveDocumentFromSurgicalPendency } from 'service/usecases/remove-document-from-surgical-pendency/remove-document-from-surgical-pendency'
import { RemoteLoadHelpPendencyHistory } from 'service/usecases/load-help-pendency-history/load-help-pendency-history'
import { RemoteCreateHelpPendencyMessage } from 'service/usecases/create-help-pendency-message/create-help-pendency-message'

export default function makeSurgicalPendencyService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const surgicalPendencyRepository = new SurgicalPendencyRepository(
    apiRepository
  )

  const answerSurgicalPendency = new RemoteAnswerSurgicalPendency(
    surgicalPendencyRepository
  )

  const loadDashboardPendencyCount = new RemoteLoadDashboardPendencyCount(
    surgicalPendencyRepository
  )

  const uploadSurgicalPendencyDocument =
    new RemoteUploadSurgicalPendencyDocument(surgicalPendencyRepository)

  const loadSurgicalOrdersByPendencyStatus =
    new RemoteLoadSurgicalOrdersByPendencyStatus(surgicalPendencyRepository)

  const loadSurgicalOrderPendencies = new RemoteLoadSurgicalOrderPendencies(
    surgicalPendencyRepository
  )

  const loadSurgicalOrderPendenciesHistory =
    new RemoteLoadSurgicalOrderPendenciesHistory(surgicalPendencyRepository)

  const loadSurgicalPendencyDocument = new RemoteLoadSurgicalPendencyDocument(
    surgicalPendencyRepository
  )

  const removeDocumentFromSurgicalPendency =
    new RemoteRemoveDocumentFromSurgicalPendency(surgicalPendencyRepository)

  const loadHelpPendencyHistory = new RemoteLoadHelpPendencyHistory(
    surgicalPendencyRepository
  )

  const createHelpPendencyMessage = new RemoteCreateHelpPendencyMessage(
    surgicalPendencyRepository
  )

  return new SurgicalPendencyService({
    answerSurgicalPendency,
    uploadSurgicalPendencyDocument,
    loadSurgicalPendencyDocument,
    loadDashboardPendencyCount,
    loadSurgicalOrdersByPendencyStatus,
    loadSurgicalOrderPendencies,
    loadSurgicalOrderPendenciesHistory,
    removeDocumentFromSurgicalPendency,
    loadHelpPendencyHistory,
    createHelpPendencyMessage
  })
}
